import SmartLabel from "@/domain/enums/SmartLabel";
import MenuItemInfo from "./MenuItemInfo";

type NavItemProps = {
    id?: SmartLabel | string;
    menuInfo?: MenuItemInfo;
    itemCount?: number;
    isFavorite?: boolean;
};

export default class NavItem {
    id?: SmartLabel | string;

    menuInfo?: MenuItemInfo;

    itemCount?: number;

    isFavorite?: boolean;

    constructor({ id, menuInfo, itemCount, isFavorite }: NavItemProps) {
        this.id = id;
        this.menuInfo = menuInfo;
        this.itemCount = itemCount;
        this.isFavorite = isFavorite;
    }
}
